import ModelAbstract from './ModelAbstract';

class FigureImage extends ModelAbstract {
    constructor({
        id = null,
        figureId = null,
        userId = null,
        url = '',
        createdAt = null,
        updatedAt = null,
    } = {}) {
        super({ id, createdAt, updatedAt });
        this.figureId = figureId;
        this.userId = userId;
        this.url = url;
    }

    /**
     * Factory method to create a FigureImage instance from API response
     * @param {Object} data - Raw figure image data from API
     * @returns {FigureImage} - Instantiated FigureImage object
     */
    static fromAPI(data) {
        if (!data) return null;
        
        return new FigureImage({
            id: data.id,
            figureId: data.figure?.id,
            userId: data.user?.id,
            url: data.url,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
        });
    }

    /**
     * Convert to plain object for JSON serialization
     */
    toJSON() {
        return {
            ...super.toJSON(),
            figureId: this.figureId,
            userId: this.userId,
            url: this.url,
        };
    }
}

export default FigureImage;
export { FigureImage }; 